<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-duration-picker
			[showTime]="false"
			[startsAt]="detailsForm.get('startsAt')"
			[endsAt]="detailsForm.get('endsAt')"></app-duration-picker>
		<div>
			<!-- <app-single-dropdown
				formControlName="recordCategory"
				[label]="
					'road-worthy-checks|record|details-section|field-label|category'
				"
				[selectOptions]="recordCategories" /> -->
			<app-input-field
				formControlName="externalReference"
				[label]="
					'road-worthy-checks|record|details-section|field-label|external-reference'
				" />
		</div>
	</form>
</app-section-wrapper-container>
